var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTickicon = function SvgTickicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Zm0 14.4A6.4 6.4 0 1 1 8 1.6a6.4 6.4 0 0 1 0 12.8Zm2.496-9.208a.4.4 0 0 1 .56 0l.4.424a.4.4 0 0 1 0 .568L6.96 10.68a.384.384 0 0 1-.56 0L4.52 8.784a.4.4 0 0 1 0-.568l.424-.424a.384.384 0 0 1 .56 0l1.2 1.192 3.792-3.792Z",
    clipRule: "evenodd"
  })));
};
export default SvgTickicon;